// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d9d81276","455":"5d6ed6b2","488":"30e14c03"}[chunkId] + ".chunk.js";
};